export const formatPrice = (amount) =>
  `Rs. ${Number(amount || 0).toLocaleString('en-PK')}`;

export const DELIVERY_FEE = 500;

export const calculateDelivery = () => DELIVERY_FEE;

export const calculateSubtotal = (items) =>
  items.reduce((sum, item) => sum + item.price * item.quantity, 0);

/** Prices always from Google Sheets — never hardcode in the frontend. */
export const resolveProductPricing = (apiProduct) => {
  const regularPrice = Number(apiProduct?.price) || 0;
  const offerPrice = Number(apiProduct?.offerPrice) || 0;
  const onSale = offerPrice > 0 && offerPrice < regularPrice;

  return {
    regularPrice,
    offerPrice: onSale ? offerPrice : 0,
    price: onSale ? offerPrice : regularPrice,
    originalPrice: onSale ? regularPrice : null,
    onSale,
    hasValidPrice: regularPrice > 0,
  };
};
